import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, catchError, of, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { ICourse } from "../models/course.model";

@Injectable()
export class CourseService{
    Courses$!:Observable<ICourse[]>;
    newCourse$!:Observable<ICourse>;
    createdCourse!:ICourse;

    private http = inject(HttpClient);
    authService = inject(AuthenticationService);

    getCourses(): Observable<ICourse[]> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ICourse[]>( environment.API_URL + '/api/Course/', options);
        } else {
            return of();
        }
    }

    getCourse(id: string|undefined ): Observable<ICourse> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ICourse>( environment.API_URL + `/api/course/ById/${id}`, options);
        } else {
            return of();
        }
    }

    deleteCourse(id: string): Observable<ICourse> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        let params = {
            id: id
        };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICourse>( environment.API_URL + `/api/course/delete`, params, options);
        } else {
            return of();
        }
    }

    createCourse(course: ICourse): Observable<ICourse> {
        const token = this.authService.getUserToken();

        course = this.sanitizeCourse(course);
        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICourse>( environment.API_URL + '/api/course/Create', course, options);
        } else {
            return of();
        }
    }

    editCourse(course: ICourse): Observable<ICourse> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ICourse>( environment.API_URL + '/api/course/update', course, options)
        } else {
            return of();
        }
    }

    changePicture(imageData: string | File | null, courseId: string): Observable<string> {
        const token = this.authService.getUserToken();

        const formData = new FormData();
        formData.append('courseId', courseId);
        if (imageData instanceof File) {
          formData.append('imageFile', imageData, imageData.name);
        }

        let options = {
            headers: new HttpHeaders( {
                'Authorization': `Bearer ${token}`
            }),
            contentType: 'multipart/form-data',
            body: formData
         };

        return this.http.post<string>( environment.API_URL + '/api/course/updatePicture', formData, options)
    }

    getNextOrder(): Observable<number> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<number>( environment.API_URL + `/api/course/getNextOrder`, options);
        } else {
            return of();
        }
    }

    sanitizeCourse(course: ICourse): ICourse {
        // Remove any properties that are not needed or are undefined
        const sanitizedCourse: ICourse = {
          ...course,
        };

        return sanitizedCourse;
    }
}
